var module = angular.module('octopusApp.library');

module.controller('StepTemplateEditController', function ($scope, $stateParams, $state, $location,
                                                          busy, octopusRepository, unsavedChanges,
                                                          templateParameterModal, pluginRegistry, $uibModal, $q, $filter, actionUpdater, actionTemplateProcessor) {
    $scope.resolveLink = $filter('resolveLink');

    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var id = $stateParams["id"];
    var actionType = $stateParams["actionType"];

    $scope.isCommunityTemplate = false;

    $scope.noprop = {};
    var queryString = $location.search();
    if (queryString.activeTab) {
        $scope.tab = queryString.activeTab;
    } else {
        $scope.tab = id ? 'step' : 'settings';
    }

    $scope.changeTab = function (selectedTab) {
        $scope.tab = selectedTab;
        $scope.unsavedChanges.ignoreNextLocationChange();
        $location.search('activeTab', selectedTab);
    };

    $scope.unsavedChanges = unsavedChanges;

    var updateLocalNames = function () {
        if ($scope.actionTemplate && $scope.actionTemplate.Parameters) {
            $scope.localNames = _.pluck(_.sortBy($scope.actionTemplate.Parameters, 'Name'), 'Name');
        } else {
            $scope.localNames = [];
        }
    };

    var validateFeatures = function () {
        if ($scope.actionTemplate && $scope.actionTemplate.Properties && $scope.actionTemplate.Properties["Octopus.Action.EnabledFeatures"]) {
            var enabledFeatures = $scope.actionTemplate.Properties["Octopus.Action.EnabledFeatures"].split(',');
            var errors = [];
            _.each(enabledFeatures, function (f) {
                var feature = pluginRegistry.getFeature(f);
                if (feature.validate) {
                    feature.validate($scope.actionTemplate, $scope.step, errors);
                }
            });

            if (errors.length > 0) {
                isSaving.showErrors("There was a problem with your request.", errors);
                return false;
            }
        }

        return true;
    };

    var actionTemplateLoader;
    if (id) {
        actionTemplateLoader = octopusRepository.ActionTemplates.get(id);
    } else {
        actionTemplateLoader = octopusRepository.ActionTemplates.search().then(function(allStepTemplates) {
            var tmpTemplate = _.find(allStepTemplates, function(template) {
                return template.Type === actionType && template.IsBuiltIn && template.IsInstalled;
            });

            var template = {ActionType: actionType, Properties: {}, Parameters: [], Links: tmpTemplate.Links};
            return template;
        });
    }

    $scope.findAction = function (actionId, steps) {
        var action = steps.map(function (step) {
            return step.Actions;
        })
            .reduce(function (result, actions) {
                return result.concat(actions);
            })
            .filter(function (action) {
                return action.Id === actionId;
            })[0];

        return action;
    };

    $scope.getParametersRequiringManualIntervention = function(action, actionTemplate){
        return actionTemplate.Parameters.filter(function(p)
        {
            var property = action.Properties[p.Name];
            if (!property) {
                return !actionUpdater.hasParameterDefaultValue(p);
            } else {
                return actionUpdater.isPropertySensitive(property) && !actionUpdater.isParameterSensitive(p);
            }
        });
    };

    $scope.updateDeploymentProcess = function (deploymentProcess, actionsToUpdate, actionTemplate, defaultPropertyValues) {
        actionsToUpdate.forEach(function(actionToUpdate){
            actionUpdater.update(actionToUpdate, actionTemplate, defaultPropertyValues);
        });

        return octopusRepository.DeploymentProcesses.modify(deploymentProcess);
    };


    $scope.getAllDeploymentProcesses = function(deploymentProcessIds){
        var promises = deploymentProcessIds.map(function(deploymentProcessId){
            return isLoading.promise(octopusRepository.DeploymentProcesses.get(deploymentProcessId));
        });

        return $q.all(promises);
    };

    $scope.mapActionsToDeploymentProcess = function(usages) {
        var deploymentProcessIds = _.uniq(usages.map(function(u){ return u.DeploymentProcessId; }));
        return $scope.getAllDeploymentProcesses(deploymentProcessIds).then(function(deploymentProcesses){
            return deploymentProcesses.map(function(deploymentProcess){
               return {
                   deploymentProcess: deploymentProcess,
                   actionsToUpdate: usages.filter(function(u){
                                              return u.DeploymentProcessId === deploymentProcess.Id;
                                           })
                                            .map(function(u){
                                                return $scope.findAction(u.ActionId, deploymentProcess.Steps);
                                            })
               };
            });
        });
    };

    $scope.updateAllProjects = function (usages) {
        $scope.mapActionsToDeploymentProcess(usages).then(function(deploymentProcessesToActions){
            var allActionsToUpdate =_.flatten(deploymentProcessesToActions.map(function(deploymentProcessToActions){
                return deploymentProcessToActions.actionsToUpdate;
            }));

            var actionsByVersion = _.groupBy(allActionsToUpdate, function(action){
               return action.Properties["Octopus.Action.Template.Version"];
            });

            var parameterHash = {};
            Object.keys(actionsByVersion).forEach(function(version){
                $scope.getParametersRequiringManualIntervention(actionsByVersion[version][0], $scope.actionTemplate)
                    .forEach(function(p) {
                        parameterHash[p.Name] = p;
                    });
            });

            var parametersToSet = Object.keys(parameterHash).map(function(name){
                return parameterHash[name];
            });

            $scope.gatherDefaultPropertyValues(parametersToSet, true)
                    .then(function (defaultPropertyValues) {
                        var promisses = deploymentProcessesToActions.map(function(group){
                            return isSaving.promise($scope.updateDeploymentProcess(group.deploymentProcess, group.actionsToUpdate, $scope.actionTemplate, defaultPropertyValues));
                        });

                        $q.all(promisses).then(function(updated){
                            $state.reload();
                        });
                    });
        });
    };

    $scope.updateAction = function (deploymentProcessId, actionId) {
        isSaving.promise(octopusRepository.DeploymentProcesses.get(deploymentProcessId).then(function(deploymentProcess){
            var action = $scope.findAction(actionId, deploymentProcess.Steps);
            var parametersToSet = $scope.getParametersRequiringManualIntervention(action, $scope.actionTemplate);
            $scope.gatherDefaultPropertyValues(parametersToSet, false)
                    .then(function (defaultPropertyValues) {
                        isSaving.promise($scope.updateDeploymentProcess(deploymentProcess, [action], $scope.actionTemplate, defaultPropertyValues))
                                .then(function (updated) {
                                    $state.reload();
                                });
                    });
        }));
    };

    $scope.gatherDefaultPropertyValues = function(parametersToSet, isGlobalUpdate){
        if (!parametersToSet.length) {
            var deferred = $q.defer();
            deferred.resolve({});
            return deferred.promise;
        }

        return $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/library/steps/views/default_action_property_values.html',
            controller: 'DefaultActionPropertyValuesController',
            dialogClass: 'modal modal-big',
            resolve: {
                parameters: function () {
                    return parametersToSet;
                },
                defaultPropertyValues: function(){
                    return {};
                },
                actionTemplateName : function(){
                    return $scope.actionTemplate.Name;
                },
                isGlobalUpdate : function(){
                    return isGlobalUpdate;
                }
            }
        }).result;
    };

    isLoading.promise(actionTemplateLoader.then(function (actionTemplate) {

        var stepTemplateLoader = actionTemplate.CommunityActionTemplateId ? octopusRepository.CommunityActionTemplates.get(actionTemplate.CommunityActionTemplateId) : $q.resolve([]);
        var feedsLoader = octopusRepository.Feeds.all();
        var loaders = [stepTemplateLoader, feedsLoader];

        isLoading.promise($q.all(loaders).then(function (results) {

            var communityStepTemplate = results[0];
            var feeds = results[1];

            $scope.actionTemplate = actionTemplate;
            $scope.communityStepTemplate = communityStepTemplate;
            $scope.hasUpdate = communityStepTemplate && actionTemplate.Version < communityStepTemplate.Version;
            $scope.isCommunityTemplate = actionTemplate.CommunityActionTemplateId != null;
            $scope.feeds = feeds;
            $scope.hasFeatures = pluginRegistry.hasFeaturesForAction(actionTemplate.ActionType);

            if (actionTemplate.Id) {
                isLoading.promise(octopusRepository.ActionTemplates.getUsage(actionTemplate).then(function (usage) {
                    $scope.usage = usage;

                    $scope.pendingUpdates = 0;
                    _.each(usage, function (u) {
                        if (u.Version.toString() !== actionTemplate.Version.toString()) {
                            $scope.pendingUpdates++;
                        }
                    });
                }));
            }

            updateLocalNames();

            $scope.templateEditor = templateParameterModal.create($scope.actionTemplate.Parameters, {
                name: 'Step Template Parameter',
                onChange: updateLocalNames
            });

            $scope.showAddFeaturesDialog = function () {
                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/projects/views/process_features_dialog.html',
                    controller: 'ProjectProcessFeaturesController',
                    dialogClass: 'modal modal-big',
                    resolve: {
                        currentAction: function () {
                            return $scope.actionTemplate;
                        },
                        currentStep: function () {
                            return null;
                        }
                    }
                });
            };

            $scope.updateTemplate = function () {

                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/library/steps/views/community_step_template_update.html',
                    controller: 'CommunityStepTemplateUpdateController',
                    resolve: {
                        actionTemplate: function () {
                            return $scope.actionTemplate;
                        },
                        communityStepTemplate: function() {
                            return $scope.communityStepTemplate;
                        }
                    }
                }).result.then(function (update) {
                    if (update) {
                        return actionTemplateProcessor.updateCommunityActionTemplateInstallation($scope.communityStepTemplate, null, isSaving)
                                                        .then(function () {
                                                            $scope.changeTab('usage');
                                                            $state.reload();
                                                        });
                    }
                });

            };

            $scope.saveAsCopy = function () {
                if (validateFeatures()) {
                    $uibModal.open({
                        backdrop: true,
                        keyboard: true,
                        templateUrl: 'areas/library/steps/views/community_step_template_saveas.html',
                        controller: 'CommunityStepTemplateSaveAsController',
                        resolve: {
                            action: function () {
                                return $scope.actionTemplate;
                            }
                        }
                    }).result.then(function (newActionName) {
                        if (newActionName) {
                            actionTemplateProcessor.cloneActionTemplate(
                                $scope.actionTemplate,
                                newActionName,
                                function(actionTemplate) { return "/library/steptemplates/" + actionTemplate.Id; },
                                isSaving,
                                function() { unsavedChanges.saved(); });
                        }
                    });
                }
            };

            $scope.save = function () {
                if (validateFeatures()) {
                    var isNew = !id;
                    isSaving.promise(octopusRepository.ActionTemplates.save($scope.actionTemplate).then(function (saved) {
                        unsavedChanges.saved();
                        if (isNew) {
                            $location.path('/library/steptemplates/' + saved.Id);
                        } else {
                            $state.reload();
                        }
                    }));
                }
            };

            $scope.export = function () {
                // Prevent exporting until changes are saved
                if (unsavedChanges.hasUnsavedChanges()) {
                    return;
                }

                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/shared/views/export_entity_dialog.html',
                    controller: 'ExportEntityDialogController',
                    dialogClass: 'modal modal-big',
                    resolve: {
                        entity: function () {
                            return $scope.actionTemplate;
                        },
                        entityType: function () {
                            return 'ActionTemplate';
                        }
                    }
                });
            };
        }));
    }));
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/step_template_edit_controller.js
// module id = 466
// module chunks = 1